var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33325 5.66669H8.99992V7.66669H4.33325V5.66669Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66675 4.33331V8.99998H5.66675V4.33331H7.66675Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6058 4.12067L16.5461 4.60574L15.3944 9.21269L13.4541 8.72762L14.6058 4.12067Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5.66669H27.6667V7.66669H23V5.66669Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3333 4.33331V8.99998H24.3333V4.33331H26.3333Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4142 12L18.6667 14.7476L17.2524 13.3334L20 10.5858L21.4142 12Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8794 17.3943L23.2724 18.546L22.7874 16.6057L27.3943 15.454L27.8794 17.3943Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24.3333H27.6667V26.3333H23V24.3333Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3333 23V27.6667H24.3333V23H26.3333Z",
    fill: "#212121"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67735 11.5846L14.7078 16.7935L20.4124 22.3253L6.31003 28.7883C5.99989 28.93 5.63115 28.9585 5.46924 28.9689C5.36262 28.9757 5.26766 28.978 5.19959 28.9786C5.16515 28.9789 5.13659 28.9788 5.11567 28.9786L5.10377 28.9784L2.97852 29.0204L3.02292 26.897L3.02276 26.8857C3.02256 26.8647 3.02245 26.8362 3.02275 26.8017C3.02336 26.7337 3.02561 26.6387 3.03246 26.5321C3.04285 26.3702 3.07138 26.0014 3.213 25.6913L9.67735 11.5846ZM5.02278 26.875L5.02281 26.8765L5.02334 26.8976L5.02163 26.9796L5.10435 26.978L5.12482 26.9785L5.12599 26.9786L5.1355 26.9787C5.14535 26.9788 5.1613 26.9788 5.18183 26.9787C5.22369 26.9783 5.28048 26.9769 5.34109 26.973C5.40366 26.969 5.45795 26.9631 5.49821 26.9562C5.50409 26.9552 5.50908 26.9543 5.51321 26.9535L16.9209 21.7254L13.2919 18.2065L10.2746 15.0821L5.04786 26.4881C5.04705 26.4923 5.04612 26.4972 5.04512 26.5031C5.03826 26.5434 5.03236 26.5977 5.02835 26.6602C5.02445 26.7209 5.02305 26.7776 5.02267 26.8195C5.02249 26.84 5.02257 26.856 5.02267 26.8658L5.02278 26.875Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryEvents);
export default __webpack_public_path__ + "static/media/category-events.de6a28cfcf829af5ca4a01541a4dca71.svg";
export { ForwardRef as ReactComponent };